import pages from "./zh-CN/pages";

export default {
  "navBar.lang": "语言",
  ...pages,
};
